import { BOOKING_URL, TEAM } from '../../lib/constants';
import { Star } from 'lucide-react';

export const Team = () => {
  return (
    <section
      id="team"
      data-testid="team-section"
      className="section-pad bg-brand-bg relative overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] rounded-full opacity-10 pointer-events-none"
        style={{ background: 'radial-gradient(circle, rgba(201,169,110,0.6) 0%, transparent 65%)' }}
      />
      <div className="container-prep relative">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <p className="eyebrow mb-5">Our Team</p>
          <h2 data-testid="team-h2" className="heading-2 mb-6">
            Meet your
            <span className="italic block text-brand-gold">lash specialists.</span>
          </h2>
          <p className="body-lg">
            Three certified lash artists. One studio. Every lash lift at Prép is
            performed by a lash specialist trained in both YUMI Keratin and
            InLei Lash Filler® systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {TEAM.map((m, i) => (
            <article
              key={m.name}
              data-testid={`team-card-${m.name.toLowerCase()}`}
              className="group bg-brand-bgElev border border-brand-gold/15 rounded-3xl p-8 hover:border-brand-gold/40 hover:shadow-[0_25px_60px_-30px_rgba(201,169,110,0.5)] hover:-translate-y-1 transition-all duration-500"
            >
              <div className="relative mb-6">
                <div className="relative w-32 h-32 mx-auto">
                  <div
                    aria-hidden
                    className="absolute -inset-2 rounded-full bg-brand-gold/20 blur-xl group-hover:bg-brand-gold/30 transition-colors"
                  />
                  <img
                    src={m.img}
                    alt={`${m.name} — ${m.role} at Prép Beauty Parlour, Vancouver`}
                    className="relative w-full h-full object-cover rounded-full border-2 border-brand-gold/30 group-hover:border-brand-gold transition-colors"
                    loading="lazy"
                  />
                </div>

                {/* rating badge */}
                <div className="absolute top-0 right-1/2 translate-x-[3.25rem] translate-y-1 inline-flex items-center gap-1 bg-brand-gold text-brand-ink px-2.5 py-1 rounded-full text-[11px] font-semibold shadow-lg">
                  <Star size={11} className="fill-brand-ink" />
                  {m.rating.toFixed(1)}
                </div>
              </div>

              <div className="text-center">
                <h3 className="font-serif text-3xl text-brand-cream mb-1">{m.name}</h3>
                <p className="eyebrow mb-5">{m.role}</p>
                <p className="text-brand-muted leading-relaxed text-sm">{m.bio}</p>
              </div>

              <div className="mt-8 pt-6 border-t border-brand-gold/15">
                <a
                  href={m.bookingUrl || BOOKING_URL}
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid={`team-book-${m.name.toLowerCase()}`}
                  className="flex items-center justify-center gap-2 text-sm font-medium text-brand-cream/85 hover:text-brand-gold transition-colors group/btn"
                >
                  Book with {m.name}
                  <span className="transition-transform group-hover/btn:translate-x-1">→</span>
                </a>
              </div>
            </article>
          ))}
        </div>

        <p className="text-center mt-12 text-brand-muted text-sm">
          Combined <span className="text-brand-gold font-semibold">15+ years</span> of lash lift expertise · YUMI & InLei certified
        </p>
      </div>
    </section>
  );
};

export default Team;
